module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/39f009351c53c95ecc2cec473d34f700.png";